import React from "react";
import { experimentalStyled, Container, Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "./PublicLayout/MdHeader/mdheader";
import Footer from "./PublicLayout/MdFooter/mdfooter";

const MainWrapper = experimentalStyled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  width: "100%",
}));

const PageWrapper = experimentalStyled(Box)(({ theme }) => ({
  flex: "1",
  display: "flex",
  flexDirection: "column",
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

const MainLayout = () => {
  return (
    <MainWrapper
      sx={{
        backgroundColor: "#e8e8e8",
      }}
    >
      <Header />

      <PageWrapper>
        <Container
          maxWidth="lg"
          sx={{
            flex: "1",
          }}
        >
          <Outlet />
        </Container>
      </PageWrapper>
    </MainWrapper>
  );
};

export default MainLayout;
